import { render, staticRenderFns } from "./BroadcastPhonePreview.vue?vue&type=template&id=a6fd6acc&scoped=true&"
import script from "./BroadcastPhonePreview.vue?vue&type=script&lang=ts&"
export * from "./BroadcastPhonePreview.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastPhonePreview.vue?vue&type=style&index=0&id=a6fd6acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fd6acc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
